import { useSelector } from "react-redux";

export default function useAuth() {
  const { loggedinUser } = useSelector((state) => state.auth) || {};

  return {
    loggedinUser: loggedinUser || {},
    isAuthenticated: loggedinUser?.token ? true : false,
  };
}
